export const baseUrl = "https://gwshc8kn48.execute-api.ap-southeast-1.amazonaws.com/Prod"
